import { getChoiceKey } from "../common/forms/utils";
import {
	COUNTRY_KEY,
	INDUSTRY_TYPE_KEY,
	TIME_ZONE_KEY,
	USER_FUNCTION_KEY,
} from "../common/forms/constants";
import { failureToError, parametersToQuery } from "../search/api";
import $ from "jquery";

const parseSubscriptionFormData = (formData) => {
	const lookingForDetailsKey = `lookingFor_${formData.lookingFor}Details`;

	delete formData.emailRepeat;
	delete formData.termsAndConditionsAgreement;
	const data = Object.assign(
		{},
		formData,
		{
			lookingForDetails: formData[lookingForDetailsKey],
		},
		{ [COUNTRY_KEY]: getChoiceKey(formData[COUNTRY_KEY]) },
		{ [INDUSTRY_TYPE_KEY]: getChoiceKey(formData[INDUSTRY_TYPE_KEY]) },
		{ [TIME_ZONE_KEY]: getChoiceKey(formData[TIME_ZONE_KEY]) },
		{ [USER_FUNCTION_KEY]: getChoiceKey(formData[USER_FUNCTION_KEY]) },
	);
	delete data.lookingFor_buyDetails;
	delete data.lookingFor_consultationDetails;
	delete data.lookingFor_trialDetails;

	return data;
};

export function submitFormData(namespace, formData, onSuccess, onError) {
	const data = JSON.stringify(parseSubscriptionFormData(formData));

	$.ajax({
		url: `/${namespace}`,
		data,
		type: "POST",
		dataType: "json",
		contentType: "application/json",
		success: onSuccess,
		error: failureToError(
			onError,
			"There was an error sending this form. Please try again later.",
		),
	});
}

export function submitEmailExists(data, onSuccess, onError) {
	$.ajax({
		url: `/subscribe-email?${parametersToQuery(data)}`,
		type: "GET",
		dataType: "json",
		contentType: "application/json",
		success: onSuccess,
		error: (jqXHR) => {
			// A 422 here means the check itself succeeded and reported a blocked
			// domain, not a request failure — handle it like a normal response.
			if (jqXHR.status === 422 && jqXHR.responseJSON) {
				onSuccess(jqXHR.responseJSON);
				return;
			}
			failureToError(onError)(jqXHR);
		},
	});
}
